const MONO = "JetBrains Mono, monospace";

export const CalibrationGauge = ({ points, frac, levelVal, liters, capacity, color }) => {
  const W = 420;
  const H = 300;
  // gauge bar
  const gx = 60;
  const gw = 90;
  const top = 40;
  const bottom = 250;
  const gh = bottom - top;
  const surfaceY = bottom - frac * gh;

  // calibration curve panel
  const cx0 = 210;
  const cx1 = 390;
  const cyTop = 40;
  const cyBot = 250;
  const maxL = points.length ? points[points.length - 1].level : 1;
  const minL = points.length ? points[0].level : 0;
  const maxV = capacity || 1;
  const px = (lvl) => cx0 + ((lvl - minL) / (maxL - minL || 1)) * (cx1 - cx0);
  const py = (v) => cyBot - (v / maxV) * (cyBot - cyTop);
  const path = points.map((p, i) => `${i === 0 ? "M" : "L"} ${px(p.level).toFixed(1)} ${py(p.liters).toFixed(1)}`).join(" ");

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full max-w-[420px] mx-auto select-none" data-testid="calibration-gauge">
      <defs>
        <linearGradient id="calibLiq" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.9" />
          <stop offset="100%" stopColor={color} stopOpacity="0.45" />
        </linearGradient>
      </defs>

      {/* gauge */}
      <text x={gx + gw / 2} y={top - 14} textAnchor="middle" fontSize="10" fill="#64748B" fontFamily={MONO}>FILL GAUGE</text>
      <rect x={gx} y={top} width={gw} height={gh} rx="8" fill="#0D131E" stroke="#3B4B63" strokeWidth="2" />
      {frac > 0.001 && <rect x={gx} y={surfaceY} width={gw} height={bottom - surfaceY} fill="url(#calibLiq)" style={{ transition: "y 0.2s" }} />}
      {frac > 0.001 && <rect x={gx} y={surfaceY - 2} width={gw} height="3" fill={color} />}
      {[0, 25, 50, 75, 100].map((t) => {
        const y = bottom - (t / 100) * gh;
        return (
          <g key={t}>
            <line x1={gx - 6} y1={y} x2={gx} y2={y} stroke="#475569" strokeWidth="1" />
            <text x={gx - 9} y={y + 3} textAnchor="end" fontSize="8.5" fill="#64748B" fontFamily={MONO}>{t}%</text>
          </g>
        );
      })}
      <text x={gx + gw / 2} y={bottom + 18} textAnchor="middle" fontSize="10" fill="#94A3B8" fontFamily={MONO}>{levelVal.toFixed(1)} cm</text>

      {/* calibration curve */}
      <text x={(cx0 + cx1) / 2} y={cyTop - 14} textAnchor="middle" fontSize="10" fill="#64748B" fontFamily={MONO}>CALIBRATION CURVE</text>
      <line x1={cx0} y1={cyBot} x2={cx1} y2={cyBot} stroke="#3B4B63" strokeWidth="1" />
      <line x1={cx0} y1={cyTop} x2={cx0} y2={cyBot} stroke="#3B4B63" strokeWidth="1" />
      {points.length >= 2 && <path d={path} fill="none" stroke="#06B6D4" strokeWidth="2" />}
      {points.map((p, i) => (
        <circle key={i} cx={px(p.level)} cy={py(p.liters)} r="3" fill="#06B6D4" />
      ))}
      {points.length >= 2 && (
        <>
          <line x1={px(levelVal)} y1={cyTop} x2={px(levelVal)} y2={cyBot} stroke="#F59E0B" strokeWidth="1" strokeDasharray="4 3" />
          <circle cx={px(levelVal)} cy={py(liters)} r="4.5" fill="#F59E0B" stroke="#0B0F17" strokeWidth="1.5" />
        </>
      )}
      <text x={cx0} y={cyBot + 16} fontSize="8.5" fill="#64748B" fontFamily={MONO}>level →</text>
      <text x={cx0 - 4} y={cyTop + 4} textAnchor="end" fontSize="8.5" fill="#64748B" fontFamily={MONO} transform={`rotate(-90 ${cx0 - 4} ${cyTop + 4})`}>L →</text>
    </svg>
  );
};
